// import {
//   UilUsersAlt,
//   UilFocusAdd,
//   UilCommentAltDownload,
//   UilChart,
//   UilTransaction,
//   UilBuilding,
//   UilChartPieAlt,
// } from "@iconscout/react-unicons";

// import { ReactComponent as Conversations } from "@/public/assets/app-images/messages.svg";

import { AppointmentPermissionKeys } from "@/services/dropdown-enums";
import { RouteLeafKey } from "@/routes/route-leaf-keys";

/** Persistence key is `routeKey` when set, otherwise `name`. `name` may still be a permission key. */

const CRMRoutes = [
  {
    path: "",
    name: "appointments",
    title: "Appointments",
    className: "appointments-nav-link",
    commonPath: "/crm/appointments/",
    redirect: false,
    haspopup: true,
    childRoutes: [
      {
        path: "/crm/appointments/dashboard",
        name: AppointmentPermissionKeys.DASHBOARD,
        routeKey: RouteLeafKey.APPOINTMENTS_DASHBOARD,
        title: "Dashboard",
        redirect: false,
      },
      {
        path: "/crm/appointments/calendars",
        name: AppointmentPermissionKeys.CALENDARS,
        title: "Calendars",
        redirect: false,
      },
      {
        path: "/crm/appointments/appointment-scheduling",
        name: AppointmentPermissionKeys.SCHEDULING,
        title: "Appointment Types",
        redirect: false,
      },
      {
        path: "/crm/appointments/appointment-members",
        name: AppointmentPermissionKeys.MEMBERS,
        title: "Team",
        redirect: false,
      },
      {
        path: "/crm/appointments/appointment-routing",
        name: AppointmentPermissionKeys.ROUTING,
        title: "Routing",
        redirect: false,
      },
    ],
  },
  {
    path: "",
    name: "lead",
    title: "Leads",
    commonPath: "/crm/leads/",
    className: "lead-nav-link",
    redirect: false,
    haspopup: true,
    childRoutes: [
      {
        path: "/crm/leads",
        name: "lead",
        title: "Leads",
        redirect: false,
      },
      {
        path: "/crm/leads/list",
        name: "list",
        title: "Lists",
        redirect: false,
      },
    ],
  },
  {
    path: "",
    name: "analytics",
    title: "Analytics",
    commonPath: "/crm/analytics/",
    className: "analytics-nav-link",
    redirect: false,
    haspopup: true,
    childRoutes: [
      {
        path: "/crm/analytics/dashboard",
        name: "dashboard",
        title: "Dashboards",
        redirect: false,
      },
      {
        path: "/crm/analytics/reports",
        name: "reports",
        title: "Reports",
        redirect: false,
      },
      {
        path: "/crm/analytics/appointments",
        name: "appointments-analytics",
        title: "Stats",
        redirect: false,
      },
    ],
  },
  {
    path: "",
    name: "automation",
    title: "Automations",
    commonPath: "/crm/automation/",
    className: "automation-nav-link",
    redirect: false,
    haspopup: true,
    childRoutes: [
      {
        path: "/crm/automation/automations",
        name: "automations",
        title: "Automations",
        redirect: false,
      },
      {
        path: "/crm/automation/templates",
        name: "template",
        title: "Templates",
        redirect: false,
      },
    ],
  },
  {
    path: "/crm/sales/tasks",
    name: "sales",
    title: "Tasks",
    className: "tasks-nav-link",
    redirect: false,
    redirectPath: ``,
    haspopup: false,
  },
];

export default CRMRoutes;
